const Elm = require('../elm/src/Main')

function initElm(elmDiv, flags) {
  const elmApp = Elm.Main.embed(elmDiv, flags)

  elmApp.ports.scrolltop.subscribe(function (scrollToTop) {
    if (scrollToTop) {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0 //Firefox
    }
  })

  elmApp.ports.redirectToHomePage.subscribe(function () {
    window.location = "/"
  })

  elmApp.ports.facebookbtn.subscribe(function (url) {
    window.open(url, 'fbShareWindow', 'height=450, width=550, top=' + (window.innerHeight / 2 - 275) + ', left=' + (window.innerWidth / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0')
  })

  new SoPost.Fingerprint2().get(function(fingerprint, components) {
    elmApp.ports.fingerprint.send(fingerprint)
  })
}

export {initElm}



// WEBPACK FOOTER //
// ./js/elm.js